export function loadGTM(gtmId) {
    if (!gtmId) return;
  
    // remove GTMs antigos
    document.querySelectorAll("script[data-gtm], iframe[data-gtm]").forEach(el => el.remove());
  
    // garante dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
  
    // ---- SCRIPT NO HEAD (Oficial) ----
    const script = document.createElement("script");
    script.dataset.gtm = gtmId;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);
  
    // ---- NOSCRIPT NO BODY (Oficial) ----
    const noscript = document.createElement("noscript");
    noscript.dataset.gtm = gtmId;
  
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
  
    document.body.prepend(noscript);
  }
  